import { sortDevices, allTemplateNonConformities, expandReference, unique, templateDeviceValue, deviceSubstitutionStatus, nPostazione, monthYearFromDateObject } from './utils'; 
import deadlines from '../components/Deadlines';
import {DataScadenzaCollaudoQuinquennaleCollaudoAnnuale, DataScadenzaManuale, DataScadenzaCollaudoRevisione, DataScadenza, DataScadenzaTagliando,DataScadenzaCollaudo } from './ScadenzeData'
import { urlFor } from './client';



/**
 * Creates an array of objects with properties:
 * Header, accessor, value, order, symbol, symbolLink, trueValue, maxWidth, minWidth
 * #registerTable
 * @param {Object[]} deviceArray - The array of devices
 * @param {Object[]} TemplateArray - The array of template fields
 * @param {Object} currentTemplate - The current template
 * 
 * @returns {Object[]} An array of objects with the above properties
 */
export const tableDataObject = (deviceArray, TemplateArray, currentTemplate) =>  deviceArray?.map?.((item, index)=>{
    //#monthlyDeadline
    //#deadlines
    const templateField = !Array.isArray(TemplateArray) ? undefined : TemplateArray?.find?.((x)=>x._id==item?.templateField?._ref)

    const value = () => {
        if(templateField?.fieldType=="boolean"){return(templateField?.value)}
        if(templateField?.dateType){
            
            if(item?.values?.length==1) {
                const obj = item?.values?.[0]
                const dateObject = obj?.dateObject
                //if(!dateObject) console.log("jkenckwecn", item)
                if(!dateObject) return `1/${obj?.value}` 
              
                return monthYearFromDateObject(dateObject)
            }
            
        } 
        if(item?.values?.length==1 && templateField?.fieldType=="dropdown"){

            return( 
                templateDeviceValue(item?.values?.[0], currentTemplate)?.toString()?.toUpperCase()
            
            )
        }
        return item?.values?.map?.((value, index)=>index > 0 ? (" " + value?.value?.toUpperCase()) : (value?.value)).toString().toUpperCase()
    }
    

    //console.log("table data:", mergeZone())

    return (
            {
            Header: TemplateArray?.find?.((x)=>x._id==item?.templateField?._ref)?.label, 
            accessor: TemplateArray?.find?.((x)=>x._id==item?.templateField?._ref)?._id, 
            value: value(),
            order: TemplateArray?.find?.((x)=>x?._id==item?.templateField?._ref)?.order,
            symbol: TemplateArray?.find?.((x)=>x?._id==item?.templateField?._ref)?.symbol,
            symbolLink: TemplateArray?.find?.((x)=>x?._id==item?.templateField?._ref)?.symbol && urlFor(!Array.isArray(TemplateArray) ? "" : TemplateArray?.find?.((x)=>x._id==item.templateField?._ref)?.symbol)?.url(),
            trueValue : TemplateArray?.find?.((x)=>x?._id==item?.templateField?._ref)?.conformityLabel,
            maxWidth: TemplateArray?.find?.((x)=>x?._id==item?.templateField?._ref)?.maxWidth,
            minWidth: TemplateArray?.find?.((x)=>x?._id==item?.templateField?._ref)?.minWidth,
            } ) }
        )
    
/**
 * Creates an array of objects with properties:
 * Header, accessor, value, order, symbol, symbolLink, trueValue, maxWidth, minWidth
 * #deadlines
 * #registerTable
 * @param {Object} device - The device object
 * @param {Object} registerTemplate - The register template object
 * 
 * @returns {Object[]} An array of objects with the above properties
 */
export const deadlineDataObject = (device, registerTemplate) => {
    //CASI SCADENZE
    const deviceTemplate = expandReference(device?.templateDevice,registerTemplate?.devices)
    const deadlineType = registerTemplate?.deadlineType?.label
    const array = () => {
        if(deadlineType == "Scadenza"){
            const {expiry} = DataScadenza(device, deviceTemplate, registerTemplate)
            return [expiry]
        }
        if(deadlineType == "Scadenza-CollaudoQuinquennale-CollaudoAnnuale"){
            const {expiry, quinquennialTest, yearlyTest} = DataScadenzaCollaudoQuinquennaleCollaudoAnnuale(device, deviceTemplate, registerTemplate)
            return [expiry, quinquennialTest, yearlyTest]
        }
        if(deadlineType == "Scadenza-Collaudo-Revisione"){
            const {expiry, collaudo, revisione} = DataScadenzaCollaudoRevisione(device, deviceTemplate, registerTemplate)
            return [expiry, collaudo, revisione]
        }
        if(deadlineType == "Scadenza-Tagliando"){
            const {expiry, collaudo,} = DataScadenzaTagliando(device, deviceTemplate, registerTemplate)
            return [expiry, collaudo]
        }
        if(deadlineType == "Scadenza-Collaudo"){
            const {expiry, collaudo,} = DataScadenzaCollaudo(device, deviceTemplate, registerTemplate)
            return [expiry, collaudo]
        }
        if(deadlineType == "ScadenzaManuale"){
            const {expiry, collaudo} = DataScadenzaManuale(device, deviceTemplate, registerTemplate)
            return [collaudo, expiry]
        }
        
        return []
    }
    
    return array().map?.((item)=>({
        Header: item?.label,
        accessor: "ddl-"+item?.fieldId, 
        value: monthYearFromDateObject(item?.dateObject),
        dateObject: item?.dateObject,
        //value: item.date,
        order: item?.order,
        symbol: item?.symbol,
        symbolLink: item?.symbolLink,
        monthlyDeadline: item?.monthlyDeadline,
        trueValue: item?.trueValue,
        maxWidth: item?.maxWidth,
        minWidth: item?.minWidth,
    }))
    
}
/**
 * Returns the maintenance tasks list for the given device and register template.
 * The list is based on the deadline type of the register template.
 * #maintenanceDeadlinesTasksList
 * #registerTable
 * @param {object} data - An object containing the device and the register template
 * @returns {array} An array containing the maintenance tasks
 */
export const maintenanceDeadlinesTasksList = (data) => {
    const {device, registerTemplate} = data
    const deviceTemplate = expandReference(device?.templateDevice,registerTemplate?.devices)
    const deadlineType = registerTemplate?.deadlineType?.label
    if(deadlineType == "Scadenza"){       
        return DataScadenza(device, deviceTemplate, registerTemplate)?.maintenanceTasksList
    }
    if(deadlineType == "Scadenza-CollaudoQuinquennale-CollaudoAnnuale"){
        return DataScadenzaCollaudoQuinquennaleCollaudoAnnuale(device, deviceTemplate, registerTemplate)?.maintenanceTasksList
    }
    if(deadlineType == "Scadenza-Collaudo-Revisione"){
        return DataScadenzaCollaudoRevisione(device, deviceTemplate, registerTemplate)?.maintenanceTasksList
    }
    if(deadlineType == "Scadenza-Tagliando"){
        return DataScadenzaTagliando(device, deviceTemplate, registerTemplate)?.maintenanceTasksList
    }
    if(deadlineType == "Scadenza-Collaudo"){
        return DataScadenzaCollaudo(device, deviceTemplate, registerTemplate)?.maintenanceTasksList
    }
    if(deadlineType == "ScadenzaManuale"){
        return DataScadenzaManuale(device, deviceTemplate, registerTemplate)?.maintenanceTasksList
    }
    return []
}

/**
 * #substituteDevice
 * Returns a string containing the device substitution reason.
 * The string is based on the device status, the existence of a substitute device, the similarity between the device and the substitute device, and the existence of substitute fields.
 * If the excludeLabel parameter is true and there is no non-conformity label, the function returns an empty string.
 * If there is a non-conformity label and the excludeLabel parameter is false, the function returns the non-conformity label.
 * If there is no non-conformity label and the excludeLabel parameter is false, the function returns a string containing the device substitution reason.
 * @param {object} data - An object containing the device, the register template, the non-conformity, the exclude label flag, and the client
 * @returns {string} A string containing the device substitution reason
 */
export const substitutionString = (data={}) => {
    const {device, registerTemplate, nonConformity, excludeLabel, client} = data
    const expiry = deadlines(device, registerTemplate)
    const currentYear = new Date().getFullYear()
    const expirySubStatus = deviceSubstitutionStatus({deviceStatus: device?.status, device, deadlines: expiry, client})
    //console.log("SUB IN CONSOLE:", device?.label, "SUB:", subStatus)
    const subDeviceEsists = device?.substituteDevice?._ref ? true : false
    const isSubSameDevice = device?.templateDevice?._ref == device?.substituteDevice?._ref
    //console.log("SUB REASON IN CONSOLE", registerTemplate)
    const subReason = () => {
        
        if(device?.substituteReason?.label) return device?.substituteReason?.label
        if(device?.substituteReason?.value) return device?.substituteReason?.value
        if(expirySubStatus == "DA SOSTITUIRE") {
            const expiryDate = expiry?.checkData?.expiry?.date
            //if(device?._id == "4e11ff4f-85d5-432e-99bc-3167c0b584a0") {console.log("SCADUTOOOO", expiry)}
            if(expiryDate && expiryDate <= currentYear) return "SCADUTO"  
            return "ADEGUAMENTO"}
        //if (!device?.substituteReason?.label && device?.substituteReason) return device?.substituteReason
        return "ADEGUAMENTO"
    }
    const templateDevices =  registerTemplate?.devices
    const subDeviceTemplate = templateDevices?.find?.(x=>x?._id == device?.substituteDevice?._ref )
    //if(device?.substituteDevice?._ref) console.log("lwnflawenf",device?.substituteDevice, subDeviceTemplate )
    const substituteTemplateFieldsProperties = !Array.isArray(registerTemplate?.fields) ? [] : registerTemplate?.fields?.filter?.(x=>x?.substitution)

    const deviceSubProperties = !Array.isArray(device?.fields) ? [] : device?.fields?.filter?.((x)=>Array.isArray(substituteTemplateFieldsProperties) && substituteTemplateFieldsProperties?.some?.((y)=>x?.templateField?._ref == y?._id))
    const areSameProperties = device?.substituteFields?.every?.((x)=>deviceSubProperties?.some?.((y)=>x?.values?.[0]?._id == y?.values?.[0]?._id))
    const subFieldsValues = device?.substituteFields?.map?.((item)=>{
        const property = !Array.isArray(substituteTemplateFieldsProperties) ? undefined : substituteTemplateFieldsProperties?.find?.((x)=> x?._id == item?.templateField?._ref)
        const value = item?.values?.length > 0 ? item?.values?.[0]?.label : ""
        const propertyLabel = () => {
            if(!property?.label) return ""
            if(property?.label == "KG/LT") return ""
            return `${property?.label} `
        }
        return value && `${propertyLabel()}${value}`
    }).filter?.((x)=>x).toString()
    
    
    const subDeviceLabel = subDeviceTemplate?.label ? subDeviceTemplate?.label : ""
    //console.log("SUB REASON IN CONSOLE kjkjhjkh", {deviceLabel: device?.label, subDeviceEsists, isSubSameDevice, areSameProperties, subDeviceLabel, subFieldsValues, nPost:nPostazione(device), expiry, subReason:subReason()})
    if(excludeLabel && !nonConformity?.substitution) return ""
    if(subReason() && subDeviceEsists && !isSubSameDevice && areSameProperties && subDeviceLabel) return `SOSTITUIRE CON ${subDeviceLabel}: ${subReason()}`
    if(subReason() && subDeviceEsists && !isSubSameDevice && !areSameProperties && subDeviceLabel) return `SOSTITUIRE CON  ${subDeviceLabel} ${subFieldsValues?.length > 0 ? subFieldsValues : ""}: ${subReason()}`
    if(subReason() && subDeviceEsists &&  isSubSameDevice && !areSameProperties && subDeviceLabel) return `SOSTITUIRE CON  ${subDeviceLabel} ${subFieldsValues?.length > 0 ? subFieldsValues : ""}: ${subReason()}`
    if(subReason()) return `SOSTITUIRE: ${subReason()}`
    if(!excludeLabel && nonConformity?.label) return nonConformity?.label
    return "SOSTITUIRE"
} 

/**
 * #nonConformities #deadlines
 * Restituisce la lista delle non conformita' del dispositivo
 * @param {Object} data - Oggetto contenente i dati relativi al dispositivo
 * @returns {Array} - Array di oggetti contenenti le non conformita' del dispositivo
 */
export const nonConformityList = (data) => {
    const {device, registerTemplate, nonConformities, deviceNonConformities, list, LDB, client} = data
    
     //CASI SCADENZE

    const maintenanceRef = maintenanceDeadlinesTasksList(data)?.map?.((item)=>({nonConformity: {_ref: item?._id} }))
   
   const templateNonConformities = allTemplateNonConformities(registerTemplate, nonConformities)

    const allNonConf = [...maintenanceDeadlinesTasksList(data), ...!Array.isArray(nonConformities) ? [] : nonConformities]
    //const allNonConf = nonConformities
    
    const deviceNonConformitiesArray = (Array.isArray(deviceNonConformities) && deviceNonConformities?.filter?.(x=> x?.device?._ref ==  device._id)) ? deviceNonConformities.filter?.(x=> x?.device?._ref ==  device._id) : []
    const maintenanceNonConf = Array.isArray(maintenanceRef) && maintenanceRef ? maintenanceRef : []

    const allDeviceNonConformities = [...deviceNonConformitiesArray, ...maintenanceNonConf].filter?.((x)=>x?.status!=="COMPLETATO" && x?.status!=="ARCHIVIATO" )
    const allNonConformities = allDeviceNonConformities?.map?.((item)=>{
        const nonConformity = !Array.isArray(allNonConf) ? {} : allNonConf?.find?.((x)=> item?.nonConformity?._ref==x?._id)
       //if(!nonConformity) console.log("NON CONFORMITIES LIST IN CONSOLE kwljdkjqwdeh", {item, nonConformity})
        const nNonConformities = item?.nNonConformities
        const nonConformityWithQuantityInLabel = {...nonConformity, label:`${nonConformity?.label} X ${item?.nNonConformities}` }
        if(+nNonConformities > 1) return nonConformityWithQuantityInLabel
        return nonConformity
    })
    ?.filter((x)=>x?.status !== "ARCHIVIATO")
    
    const expiry = deadlines(device, registerTemplate)
    const expirySubStatus = deviceSubstitutionStatus({deviceStatus: device?.status, device, deadlines: expiry, client})
 
    const subNonConformityExists = allNonConformities?.some?.((y)=>y?.substitution)
    const finalNonConformities = () => {
        if(!subNonConformityExists && expirySubStatus == "DA SOSTITUIRE") return [...allNonConformities, {label: substitutionString(data) }] 
        if(device?.status == "DA FORNIRE") return  [...allNonConformities, {label: "DA FORNIRE"}] 
        return [...allNonConformities]
    }

    const toReturn = finalNonConformities()?.map?.((nonConformity, index)=>{
        
        const translatedLabel = (label) => {
            if(label == "SCADUTO SOSTITUIRE") return LDB("fields", "expired")
            return label
        }
        const label = () => {
            if(nonConformity?.substitution) return substitutionString(data)
            return translatedLabel(nonConformity?.label, LDB)

        }
        if(list){
            if(index==0) return label()
            return " "+ label()
        }
        return {nonConformity}

    
    })
    
    
    return toReturn
}


/**
 * Returns an object containing the data for the register table
 * #registerTable
 * #pdfRegister
 * @param {Object} data Configuration object containing required data
 * @param {Array} data.devices Array of device objects
 * @param {Object} data.registerTemplate Register template object
 * @param {Array} data.nonConformities Array of non-conformity objects
 * @param {Array} data.deviceNonConformities Array of device non-conformity objects
 * @param {Function} data.LDB Function to get the label of a given key
 * @param {Object} data.client Client information
 * @returns {Object} Object containing the data for the register table
 */
export const registerTableData = (data) => {
    
    const {devices, registerTemplate, nonConformities, deviceNonConformities, LDB, client} = data
    const sortDevicesBy = "Posizione"
    
    const tableData = !registerTemplate ? [] : devices
    ?.sort((a,b)=> sortDevices(a,b, sortDevicesBy))
    ?.map?.((item => {

        const mergeZone = () => {    
            const zoneId = "d770ea67-ef56-404d-a7be-37f18f6ea8be"
            const areaId = "2e587bd1-e26e-4938-9c26-d7c16199ffe6"

            const zoneField = !Array.isArray(item?.locations) ? {} : item?.locations?.find?.((x)=>x?.templateField?._ref == zoneId) 
            const areaField = !Array.isArray(item?.locations) ? {} : item?.locations?.find?.((x)=>x?.templateField?._ref == areaId)

            if(zoneField?.values?.[0]?.label && areaField?.values?.[0]?.label){
                const filteredArray = !Array.isArray(item?.locations) ? [] : item?.locations?.filter?.(x=>x?.templateField?._ref !== zoneId && x?.templateField?._ref !== areaId)
                const updatedArray = [...filteredArray, {...areaField, values:[...areaField?.values, ...zoneField?.values]}]
                return updatedArray
            }
            if(zoneField?.values?.[0]?.label && !areaField?.label){
                const filteredArray = !Array.isArray(item?.locations) ? [] : item?.locations?.filter?.(x=>x?.templateField?._ref !== zoneId)
                const updatedArray = [...filteredArray, {templateField:{_ref: areaId, _type: "reference"}, values:[...zoneField?.values]}]
                return updatedArray
            }
            
            return item?.locations
        }
        const nonConformitiesData = {
            device: item, 
            registerTemplate, 
            nonConformities, 
            deviceNonConformities, 
            list: true, 
            client,
            LDB
        }
    
        const templateDevice = expandReference(item?.templateDevice, registerTemplate?.devices)
        //console.log("òoq3jfòoqrjhf", templateDevice)

        return (
        {   
            locations: tableDataObject(mergeZone(), registerTemplate?.locations),
            _id: [{Header:"ID", accessor:"_id", value: item?._id}],
            presidio: [{Header:"PRESIDIO", accessor:"presidio", value: templateDevice?.label}],
            fields: tableDataObject(item?.fields, registerTemplate?.fields, registerTemplate),
            dates: tableDataObject(item?.dates, registerTemplate?.dates),
            deadlines: deadlineDataObject(item, registerTemplate),
            nonConformita: [{Header:"NON CONFORMITA'", accessor:"nonConformita", value: nonConformityList(nonConformitiesData).toString()}],
            esito: [{Header:"ESITO NEGATIVO", accessor:"esito", value: nonConformityList(nonConformitiesData).length>0 ? "X":""}],
            info: [{Header:"INFO", accessor:"info", value: ""}],
        }  
        )
    })) 
        
 
    const tableDataArray = !tableData ? [] : tableData?.map?.((item => {
        const locations = !item?.locations ? [] : item?.locations
        const fields = !item?.fields ? [] : item?.fields
        const dates = !item?.dates ? [] : item?.dates
        const deadlines = !item?.deadlines ? [] : item?.deadlines
        const nonConformita = !item?.nonConformita ? [] : item?.nonConformita
        return([
        ...item?._id,...locations, ...item?.presidio, ...fields, ...dates, ...deadlines, ...nonConformita, ...item?.esito, ...item?.info
    ])}))

    //console.log("table columns",tableData()) 

    const tableValues = !tableDataArray ? [] : tableDataArray?.map?.((x)=> x.map?.((item)=>({[item.accessor]: item.value})).reduce(((r, c) => Object.assign(r, c)), {}))

    //console.log("table columns",tableValues) 
 

        // TABLE COLUMNS 

/*     const unique =  (key, array) => {
        const arrayUniqueByKey = [...new Map(array?.map?.(item =>
        [item[key], item])).values()];
        return arrayUniqueByKey
        } */
        
    const uniqueTableDataArray = unique("accessor",tableDataArray?.flat(2))

    const tableColumns = uniqueTableDataArray.map?.((item => ({
        accessor: item.accessor,
        Header: item.Header,
        order: item.order,
        symbol: item.symbol,
        symbolLink: item.symbolLink,
        monthlyDeadline: item.monthlyDeadline,
        trueValue: item.trueValue,
        maxWidth: item.maxWidth,
        minWidth: item.minWidth,
    })))
  
    // result
      const allTemplateFields = [
        ...!Array.isArray(registerTemplate?.fields) ? [] : registerTemplate?.fields,
        ...!Array.isArray(registerTemplate?.locations) ? [] : registerTemplate?.locations,
        ...!Array.isArray(registerTemplate?.dates) ? [] : registerTemplate?.dates,
      ]
      const archievedTemplateFields = allTemplateFields?.filter((x)=>x?.status == "ARCHIVIATO")?.map((x)=>x?._id)
    //console.log("lkasmdlasmdalksdm", {archievedTemplateFields})
    const hiddenColumns = tableColumns?.map?.((item)=>{
        
        const hiddenProperties = !registerTemplate?.fields ? [] :  registerTemplate?.fields.filter?.(x=>x.hiddenToClient)
        if(!Array.isArray(hiddenProperties) ? undefined : hiddenProperties?.find?.(x=>x?._id==item?.accessor))return item?.accessor
        return (undefined)
    }).filter?.(y=>y)

    const tableResultData = {
    hideColumns: ["_id","d770ea67-ef56-404d-a7be-37f18f6ea8be", "b5d2372c-ca55-4d24-a5a6-7c839249b51f",...hiddenColumns, ...archievedTemplateFields],
    //hideColumns: [],
    columns: tableColumns?.filter?.((x)=>x?.accessor),
    data: tableValues,
    }

    return tableResultData
}

const logo = (customer) => {
    if(customer?.logoHeader) return urlFor(customer?.logoHeader && customer?.logoHeader)?.url()
    return "/assets/logo192.png"
}
const signature = (customer) => {
    if(customer?.signature) return urlFor(customer.signature && customer.signature)?.url()
    return ""
}
const logoWidth = (customer) => {
    if(customer?.logoHeaderSize?.width) return customer?.logoHeaderSize?.width
    return 74
}
const logoHeight = (customer) => {
    if(customer?.logoHeaderSize?.height) return customer?.logoHeaderSize?.height
    return 74
}

/**
 * Returns an object containing data for the header of the report.
 *#pdfRegister
 #registerTable
 * @param {Object} customer - The customer object from Sanity.
 * @param {Object} client - The client object from Sanity.
 * @param {Object} site - The site object from Sanity.
 * @param {Object} currentTemplate - The current register template object from Sanity.
 * @param {Object} register - The register object from Sanity.
 * @param {Object} lastLog - The last log object from Sanity.
 * @param {Function} LDB - A function that retrieves a label from the database.
 * @returns {Object} An object containing data for the header of the report.
 */
export const headerData = (customer,client,site,currentTemplate,register,lastLog, LDB) => ({

        customerLogo: logo(customer),
        customerLogoWidth:logoWidth(customer),
        customerLogoHeight:logoHeight(customer),
        customerSignature: signature(customer),
        client: client?.label,
        clientLabel:LDB("misc","client"),
        addressLabel:LDB("misc","address"),
        notComune: client?.notComune,
        site: site?.label,
        siteLabel: LDB("misc","site"),
        siteNumber: site?.siteNumber,
        siteTitle: site?.siteNumber ? `${LDB("misc","site")} ${site?.siteNumber}: ${site?.label}` : site?.label,
        registerName:register?.registerName,
        houseNumber: site?.houseNumber ? site.houseNumber + ", " : "",
        address1: (site?.address1 ? site.address1 + ", " : "")?.toUpperCase(),
        address2: (site?.address2 ? site.address2 + ", " : "")?.toUpperCase(),
        postcode: (site?.postCode ? site.postCode + ", " : "")?.toUpperCase(),
        city: (site?.city ? site.city: "")?.toUpperCase(),
        register: currentTemplate?.family,
        registerIcon: currentTemplate?.icon,
        templateRegisterFields: currentTemplate?.registerFields,
        registerNonConformities: register?.registerNonConformities,
        technician: lastLog?.postedBy,
        lastCheck: lastLog?.date,
        description: currentTemplate?.description,
        notes: LDB("misc","registerNotes")?.toUpperCase(),


})